module.exports = __webpack_public_path__ + "img/imageVideo.28e43b56.jpg";